
const Sidebar: React.FC = () => {return(



        <ul className="navbar-nav bg-nav-bar sidebar sidebar-dark accordion" id="accordionSidebar">

            <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/dashboard">
                <div className="sidebar-brand-icon rotate-n-15">
                </div>
                <div className="sidebar-brand-text mx-3">Solar Dashboard App</div>
            </a>

            <hr className="sidebar-divider my-0"/>

            <li className="nav-item active">
                <a className="nav-link" href="/dashboard">
                    <i className="fas fa-fw fa-tachometer-alt"></i>
                    <span>Dashboard</span></a>
            </li>

            <hr className="sidebar-divider"/>

            <div className="sidebar-heading">
                Profile - Operations
            </div>

            <li className="nav-item">
                <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                    <i className="fas fa-fw fa-cog"></i>
                    <span>Profile</span>
                </a>
                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <h6 className="collapse-header"></h6>
                        <a className="collapse-item" href="/profile">Profile</a>
                        <a className="collapse-item" href="/register">New Registeration</a>
                    </div>
                </div>
            </li>

            <hr className="sidebar-divider"/>

            <li className="nav-item">
                <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages" aria-expanded="false" aria-controls="collapsePages">
                    <i className="fas fa-fw fa-folder"></i>
                    <span>Solar Users</span>
                </a>
                <div id="collapsePages" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar" >
                    <div className="bg-white py-2 collapse-inner rounded">
                        <a className="collapse-item" href="/add-solar-user">
                            <i className="fas fa-fw fa-table"></i>
                            <span>Add Solar User</span>
                        </a>
                         <a className="collapse-item" href="/solar-users">
                            <i className="fas fa-fw fa-table"></i>
                            <span>Solar User List</span>
                        </a>
                    </div>
                </div>
            </li>
           

            

        </ul>
);}

export default Sidebar;